import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=1ad13647&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad13647')) {
      api.createRecord('1ad13647', component.options)
    } else {
      api.reload('1ad13647', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=1ad13647&", function () {
      api.rerender('1ad13647', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22flxrdIrOFIn/JS/comp/IncreaseNumber.vue"
export default component.exports